if (!customElements.get('quick-links-slider')) {
  class QuickLinksSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-quick-links-track]');
      this.nav = this.querySelector('[data-quick-links-nav]');
      this.prev = this.querySelector('[data-quick-links-prev]');
      this.next = this.querySelector('[data-quick-links-next]');
      if (!this.track) return;

      this.showArrowsMobile = this.dataset.showArrowsMobile !== 'false';

      this._onScroll = () => this._updateArrowVisibility();
      this._onResize = () => this._scheduleOverflowCheck();
      this._onBreakpoint = () => this._scheduleOverflowCheck();

      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize);
      document.addEventListener('matchMobile', this._onBreakpoint);
      document.addEventListener('unmatchMobile', this._onBreakpoint);

      if (typeof ResizeObserver !== 'undefined') {
        this._ro = new ResizeObserver(() => this._scheduleOverflowCheck());
        this._ro.observe(this.track);
        const vp = this.querySelector('[data-quick-links-viewport]');
        if (vp) this._ro.observe(vp);
      }

      this.prev?.addEventListener('click', () => this._scrollBy(-1));
      this.next?.addEventListener('click', () => this._scrollBy(1));

      this._scheduleOverflowCheck();
      if (document.fonts?.ready) {
        document.fonts.ready.then(() => this._scheduleOverflowCheck());
      }
      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => this._scheduleOverflowCheck(), { once: true });
      }
    }

    _scheduleOverflowCheck() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this._updateOverflow());
      });
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('matchMobile', this._onBreakpoint);
      document.removeEventListener('unmatchMobile', this._onBreakpoint);
      this._ro?.disconnect();
    }

    _isMobileViewport() {
      if (typeof FoxTheme !== 'undefined' && FoxTheme.config && typeof FoxTheme.config.mqlMobile === 'boolean') {
        return FoxTheme.config.mqlMobile;
      }
      return window.matchMedia('(max-width: 767px)').matches;
    }

    _shouldShowNav(overflowing) {
      if (!overflowing) return false;
      if (this._isMobileViewport() && !this.showArrowsMobile) return false;
      return true;
    }

    _scrollBy(direction) {
      const amount = Math.max(this.track.clientWidth * 0.72, 140);
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    _updateOverflow() {
      if (!this.track) return;
      const tol = 1;
      const scrollW = Math.ceil(this.track.scrollWidth);
      const clientW = Math.floor(this.track.getBoundingClientRect().width);
      const overflowing = scrollW > clientW + tol;
      this.classList.toggle('quick-links__slider--overflowing', overflowing);
      if (this.nav) {
        this.nav.toggleAttribute('hidden', !this._shouldShowNav(overflowing));
      }
      this._updateArrowVisibility();
    }

    _updateArrowVisibility() {
      if (!this.nav || this.nav.hidden) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const max = Math.max(0, scrollWidth - clientWidth);
      const tol = 2;

      if (this.prev) {
        this.prev.hidden = scrollLeft <= tol;
      }
      if (this.next) {
        this.next.hidden = scrollLeft >= max - tol;
      }
    }
  }

  customElements.define('quick-links-slider', QuickLinksSlider);
}
